module.exports = __webpack_public_path__ + "img/nh_current_route.25540f03.png";